import { LOAD_DISPLAY_STATUS_CONSTANTS, LOAD_STATUS_STRING } from '../constants/index';

export const GET_LOAD_STATUS_TEXT = (status: string): string => {
	switch (status.toLowerCase()) {
		case LOAD_STATUS_STRING.DELIVERED.toLowerCase():
			return LOAD_DISPLAY_STATUS_CONSTANTS.DELIVERED;
		case LOAD_STATUS_STRING.ACTIVE.toLowerCase():
			return LOAD_DISPLAY_STATUS_CONSTANTS.ACTIVE;
		case LOAD_STATUS_STRING.CONFIRMED.toLowerCase():
			return LOAD_DISPLAY_STATUS_CONSTANTS.CONFIRMED;
		case LOAD_STATUS_STRING.DELETED.toLowerCase():
			return LOAD_DISPLAY_STATUS_CONSTANTS.DELETED;
		case LOAD_STATUS_STRING.CANCELLED.toLowerCase():
			return LOAD_DISPLAY_STATUS_CONSTANTS.CANCELLED;
		case LOAD_STATUS_STRING.IN_TRANSIT.toLowerCase():
			return LOAD_DISPLAY_STATUS_CONSTANTS.IN_TRANSIT;
		case LOAD_STATUS_STRING.EXPIRED.toLowerCase():
			return LOAD_DISPLAY_STATUS_CONSTANTS.EXPIRED;
		case LOAD_STATUS_STRING.SELECTED.toLowerCase():
			return LOAD_DISPLAY_STATUS_CONSTANTS.SELECTED;
		default:
			return 'Requested';
	}
};
